export const WEATHER_BASE_URL = 'https://api.open-meteo.com/';
export const GEO_BASE_URL = 'https://geocoding-api.open-meteo.com/';